import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { publicApi, useApi } from "@/lib/api";

const SessionCtx = createContext(null);
const SiteCtx = createContext({});

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  useEffect(() => {
    publicApi.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({ brand_name: "Minha Contabilidade AI" }));
  }, []);
  return <SiteCtx.Provider value={site || {}}>{children}</SiteCtx.Provider>;
}
export const useSite = () => useContext(SiteCtx);

export function SessionProvider({ children }) {
  const api = useApi();
  const { isSignedIn, isLoaded } = useAuth();
  const [me, setMe] = useState(null);
  const [companyId, setCompanyIdState] = useState(localStorage.getItem("mcai_company") || "");
  const [orgId, setOrgIdState] = useState(localStorage.getItem("mcai_org") || "");

  const reload = useCallback(async () => {
    const { data } = await api.get("/me");
    setMe(data);
    return data;
  }, [api]);

  useEffect(() => {
    if (isLoaded && isSignedIn) reload().catch(() => setMe({ error: true }));
    if (isLoaded && !isSignedIn) setMe(null);
  }, [isLoaded, isSignedIn, reload]);

  const setCompanyId = (id) => { localStorage.setItem("mcai_company", id || ""); setCompanyIdState(id || ""); };
  const setOrgId = (id) => { localStorage.setItem("mcai_org", id || ""); setOrgIdState(id || ""); };
  const company = me?.companies?.find((c) => c.id === companyId) || null;
  const can = (res, mode = "r") => (company?.perms?.[res] || "").includes(mode === "w" ? "w" : "r") || (mode === "r" && company?.perms?.[res] === "w");

  return (
    <SessionCtx.Provider value={{ me, reload, companyId, setCompanyId, orgId, setOrgId, company, can, api }}>
      {children}
    </SessionCtx.Provider>
  );
}
export const useSession = () => useContext(SessionCtx);
